import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getGroups = async() => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Group`,
  );
    
  return data;
};

export const getGroupTemplates = async() => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Group/templates`
  );
    
  return data;
};

export const getGroupInfo = async(id) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Group/${id}`,
  );

  return data;
};

export const getTemplateGroupPermissions = async(id) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get(
    `${API_BACKEND_HOST}${languageId}/v1/Group/${id}/template-functionalities`,
  );

  return data;
};

export const verifyGroupMembers = async({
  committeePackageId,
  participantsIds,
  groupId,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/Group/verify-member-groups`,
    {
      committeePackageId,
      participantsIds,     
      groupId,     
    }
  );

  return data;
};

export const createGroup = async({
  name,
  committeePackageId,
  participantsIds,
  functionalitiesIds,
  accessModelAllContent,
  accessModelModalityBased,
  groupAdminLevel,
  accessModelDirectoryBased,
  modalitiesIds,
  accessModelResponsibleBased,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/Group`,
    {
      name,
      committeePackageId,
      participantsIds,
      accessModelModalityBased,
      accessModelAllContent,
      groupAdminLevel,
      ...(modalitiesIds && accessModelModalityBased && ({modalitiesIds})),
      accessModelDirectoryBased,
      accessModelResponsibleBased,
      functionalitiesIds
    }
  );

  return data;
};

export const toggleActive = async (id, active) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/Group/${id}`,
    {
      active
    },
  );

  return data;
};

export const updateGroup = async({
  id,
  name,
  committeePackageId,
  participantsIds,
  modalitiesIds,
  functionalitiesIds,
  accessModelModalityBased,
  accessModelAllContent,
  accessModelDirectoryBased,
  accessModelResponsibleBased,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.put(
    `${API_BACKEND_HOST}${languageId}/v1/Group/${id}`,
    {
      name,
      committeePackageId,
      participantsIds,
      accessModelModalityBased,
      accessModelAllContent,
      accessModelDirectoryBased,
      ...(modalitiesIds && accessModelModalityBased ? ({ modalitiesIds }) : ({ nodalitiesIds: [] })),
      accessModelResponsibleBased,
      functionalitiesIds
    }
  );

  return data;
};

export const addUserToGroup = async({
  groupId,
  userId,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/Group/id:Guid/member/id:Guid`,
    {
      
    }, 
    {
      params: {
        'memberId': userId,
        'groupId': groupId
      }
    }
  );

  return data;
};

export const removeUserFromGroup = async({
  groupId,
  userId,
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.delete(
    `${API_BACKEND_HOST}${languageId}/v1/Group/id:Guid/member/id:Guid`,
    {
      params: {
        'memberId': userId,
        'groupId': groupId
      }
    }
  );

  return data;
};
